import { Headline } from '@oneaudi/unified-web-components';
import ConsumptionFootnote from '~/app/compositions/content/calculation-info/components/consumption-footnote';
import { FooterCarlineStyle } from '~/app/compositions/content/service-footer/components/user-marketing/styles/footer-carline-style';
import { useMarketConfig } from '~/app/market-config';
import { useConfigurator } from '~/graphql/hooks/use-configurator';
import { DATA_TEST_ID } from '~/test/data-test-id';

export function FooterCarline() {
	const {
		catalog: { carInfo },
	} = useConfigurator();
	const carline = carInfo?.carline ?? 'Carline';
	const model = carInfo?.model ?? 'Model';
	const { config } = useMarketConfig();

	return (
		<FooterCarlineStyle data-testid={DATA_TEST_ID.CAR_TITLE}>
			<div>
				<Headline
					tag={'h5'}
					variant={{ type: 'display', order: '1', weight: 'bold' }}
					className="headline__main">
					{carline}
				</Headline>
				<Headline
					tag={'h5'}
					variant={{ type: 'display', order: '1', weight: 'normal' }}
					className="headline__sub">
					{model}
					{!config.hideConsumptionEmissionEngineName && <ConsumptionFootnote />}
				</Headline>
			</div>
		</FooterCarlineStyle>
	);
}
